import {
    GET_SAVED_CAMPAIGNS,
    GET_SAVED_CAMPAIGNS_SUCCESS,
    GET_SAVED_CAMPAIGNS_FAILED,
} from './actionTypes';


const initialState = {
    error: "",
    loading: false,
    saved_campaigns: undefined
}

const savedCampaigns = (state = initialState, action) => {
    switch (action.type) {
        case GET_SAVED_CAMPAIGNS:
            state = {
                ...state,
                loading: true
            }
            break;
        case GET_SAVED_CAMPAIGNS_SUCCESS:
            state = {
                ...state,
                loading: false,
                saved_campaigns: action.payload
            }
            break;
        case GET_SAVED_CAMPAIGNS_FAILED:
            state = {
                ...state,
                loading: false
            };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default savedCampaigns;